import React from "react";
import { Plus, Trash2, Timer } from "lucide-react";

export const DEFAULT_ROTEIRO_CONFIG = {
  faixas_previa: [
    { max_atletas: 3, minutos: 5 },
    { max_atletas: 6, minutos: 8 },
    { max_atletas: 10, minutos: 12 },
    { max_atletas: 15, minutos: 15 },
  ],
  classificados_final: 5,
  min_por_atleta_final: 1,
};

const num = (v, fallback = 0) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : fallback;
};

export const RoteiroConfigEditor = ({ value, onChange }) => {
  const cfg = { ...DEFAULT_ROTEIRO_CONFIG, ...(value || {}) };
  const faixas = cfg.faixas_previa || [];
  const set = (patch) => onChange({ ...cfg, ...patch });
  const setFaixa = (i, patch) => set({ faixas_previa: faixas.map((f, j) => (j === i ? { ...f, ...patch } : f)) });
  const addFaixa = () => {
    const last = faixas[faixas.length - 1];
    set({ faixas_previa: [...faixas, { max_atletas: (last?.max_atletas || 0) + 5, minutos: (last?.minutos || 0) + 3 }] });
  };
  const removeFaixa = (i) => set({ faixas_previa: faixas.filter((_, j) => j !== i) });

  return (
    <div className="border border-white/10 p-3 space-y-3" data-testid="roteiro-config">
      <label className="overline block flex items-center gap-2">
        <Timer size={12} /> Tempos do roteiro
      </label>

      <div>
        <div className="text-[11px] text-[var(--text-secondary)] mb-1">
          PRÉVIA — minutos por faixa de atletas inscritos (0 atletas = 0 min; acima da última faixa: +1 min por atleta excedente)
        </div>
        <div className="space-y-1">
          {faixas.map((f, i) => {
            const lo = i === 0 ? 1 : (faixas[i - 1]?.max_atletas || 0) + 1;
            return (
              <div key={i} className="grid grid-cols-[auto_1fr_auto_1fr_auto] items-center gap-2 text-sm" data-testid={`faixa-row-${i}`}>
                <span className="text-[11px] text-[var(--text-secondary)] tabular-nums w-10 text-right">{lo} a</span>
                <input
                  data-testid={`faixa-max-${i}`}
                  type="number"
                  min={lo}
                  className="input-field !py-1 text-center"
                  value={f.max_atletas}
                  onChange={(e) => setFaixa(i, { max_atletas: num(e.target.value, lo) })}
                />
                <span className="text-[11px] text-[var(--text-secondary)]">atletas →</span>
                <input
                  data-testid={`faixa-min-${i}`}
                  type="number"
                  min={0}
                  className="input-field !py-1 text-center"
                  value={f.minutos}
                  onChange={(e) => setFaixa(i, { minutos: num(e.target.value, 0) })}
                />
                <button
                  type="button"
                  data-testid={`faixa-del-${i}`}
                  className="btn-ghost !px-2 !py-1"
                  disabled={faixas.length <= 1}
                  onClick={() => removeFaixa(i)}
                  title="Remover faixa"
                >
                  <Trash2 size={12} />
                </button>
              </div>
            );
          })}
        </div>
        <button type="button" data-testid="faixa-add" className="btn-ghost !py-1 !text-xs mt-2 inline-flex items-center gap-1" onClick={addFaixa}>
          <Plus size={12} /> Adicionar faixa
        </button>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="text-[11px] text-[var(--text-secondary)] block mb-1">FINAL — nº de classificados</label>
          <input
            data-testid="cfg-classificados"
            type="number"
            min={1}
            className="input-field !py-1"
            value={cfg.classificados_final}
            onChange={(e) => set({ classificados_final: num(e.target.value, 1) })}
          />
        </div>
        <div>
          <label className="text-[11px] text-[var(--text-secondary)] block mb-1">FINAL — min por atleta</label>
          <input
            data-testid="cfg-min-final"
            type="number"
            min={0}
            className="input-field !py-1"
            value={cfg.min_por_atleta_final}
            onChange={(e) => set({ min_por_atleta_final: num(e.target.value, 0) })}
          />
        </div>
      </div>
      <div className="text-[11px] text-[var(--text-secondary)]">
        Final = min(classificados, inscritos) × min/atleta. Horários do roteiro = início do evento + soma sequencial (prévias → intervalo → finais).
      </div>
    </div>
  );
};
